/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ==========================================================================
   Correctif : boutons + et - du panier
   Ajoute le 2026-08-08.

   Pourquoi ce code existe :
   Le layout desactive la section header standard (theme.liquid, le bloc
   {%- sections 'header-group' -%} est en commentaire) et la remplace par
   {% render 'header-premium' %}.

   Or c'est la classe Header de theme.js qui instancie la classe Cart, et
   Header ne s'active que sur un element [data-section-type="header"], fourni
   par la section desactivee. Sans elle, Cart n'est jamais construit, et les
   ecouteurs des boutons de quantite ne sont jamais attaches.

   Ce script rebranche uniquement le changement de quantite, sans toucher au
   reste du theme. Si la section header standard est un jour reactivee, ce
   code reste inoffensif : il ferait le meme travail, une seule fois, car la
   page se recharge apres chaque changement.
   ========================================================================== */
(function () {
  'use strict';

  var SELECTEUR_BOUTONS =
    '[data-action="decrease-quantity"], [data-action="increase-quantity"]';

  function changerQuantite(ligne, quantite) {
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ line: ligne, quantity: quantite })
    })
      .then(function () {
        window.location.reload();
      })
      .catch(function () {
        // En cas d'echec reseau, on recharge quand meme : le panier affichera
        // l'etat reel du serveur plutot qu'un etat incertain.
        window.location.reload();
      });
  }

  document.addEventListener('click', function (evenement) {
    if (!evenement.target || !evenement.target.closest) return;

    var bouton = evenement.target.closest(SELECTEUR_BOUTONS);
    if (!bouton) return;

    var ligne = parseInt(bouton.getAttribute('data-line'), 10);
    var quantite = parseInt(bouton.getAttribute('data-quantity'), 10);
    if (isNaN(ligne) || isNaN(quantite) || quantite < 0) return;

    evenement.preventDefault();
    changerQuantite(ligne, quantite);
  });

  document.addEventListener('change', function (evenement) {
    if (!evenement.target || !evenement.target.closest) return;

    var champ = evenement.target.closest('.quantity-selector__value');
    if (!champ) return;

    var ligne = parseInt(champ.getAttribute('data-line'), 10);
    var quantite = parseInt(champ.value, 10);
    if (isNaN(ligne) || isNaN(quantite) || quantite < 0) return;

    changerQuantite(ligne, quantite);
  });
})();
